import template from './adpModal.html';
import controller from './adpModal.controller';
import './adpModal.less';

let adpModalComponent = {
  restrict: 'E',
  bindings: {
    show: '='
  },
  template,
  transclude: true,
  controller
};

export default adpModalComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpModal/adpModal.component.js